import { zergApi } from "@/service/zerg";

class DashboardService {

    async getAttendanceByEmployee(params) {
        try {
            const data = await zergApi.post("/driver/dashboard/get-attendance-by-employee", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAttendanceByDay(params) {
        try {
            const data = await zergApi.post("/driver/dashboard/get-attendance-by-day", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getWeekViaticByEmployee(params) {
        try {
            const data = await zergApi.post("/driver/dashboard/get-week-viatic-by-employee", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new DashboardService();